import React, { useState } from 'react';
import { Fade } from '@material-ui/core';
import { useAsyncWait } from 'globals/hooks/useAsyncWait';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsInviteNewCustomerForm from 'ui-elements/forms/FsInviteNewCustomerForm';
import defaultLocales from 'globals/locales/default';
import { useStyles } from './InviteCustomerForm.style';
import { ContextBox } from './InviteCustomerForm.style-elements';

const InviteCustomerForm: React.FC = () => {
  const { paper: paperClass } = useStyles();
  const [inStatus, setInStatus] = useState<boolean>(false);

  useAsyncWait(setInStatus);

  return (
    <Fade in={inStatus} timeout={1000}>
      <FsPaper className={paperClass} title={defaultLocales.inviteCustomer}>
        <ContextBox>
          <FsInviteNewCustomerForm />
        </ContextBox>
      </FsPaper>
    </Fade>
  );
};

export default InviteCustomerForm;
